/**
 * Opportunity analytics — thin wrapper over api/opportunity-stage-history.js's `analytics` action.
 * See that file's header for the exact shape and honesty caveats (history only exists from
 * 2026-07 forward, no retroactive backfill, Proposal Posted transitions aren't captured yet).
 */
async function clerkToken() {
  try { return typeof window.__clerkGetToken === 'function' ? await window.__clerkGetToken().catch(() => null) : null } catch { return null }
}

/** { currentFunnel: {[stage]: count}, historical: {sampleSize, winRate, avgCycleDays, oldestEntryAt} | null } */
export async function getPipelineAnalytics() {
  const token = await clerkToken()
  const res = await fetch('/api/opportunity-stage-history', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify({ action: 'analytics' }),
  })
  if (!res.ok) throw new Error('Could not load pipeline analytics.')
  return res.json()
}

/** This one opportunity's own stage-change trail, newest first. */
export async function getOpportunityStageHistory(projectId) {
  const token = await clerkToken()
  const res = await fetch('/api/opportunity-stage-history', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    body: JSON.stringify({ action: 'forProject', projectId }),
  })
  if (!res.ok) throw new Error('Could not load stage history.')
  const { history } = await res.json()
  return history || []
}
